const fakeAuth = {
  hardcoded: {
    u: 'administrator',
    p: 'Sxdcfv@10',
  },
  getCredentials() {
    return {
      token: localStorage.getItem('cs.authtoken'),
      isAdmin: localStorage.getItem('cs.isAdmin') === 'true'
    }
  },
  isAdmin() {
    return localStorage.getItem('cs.isAdmin') === 'true' ? true : false;
  },
  isAuthenticated() {
    return localStorage.getItem('cs.isAuthenticated') || false;
  }, //|| false, // this should be persisted ?
  authenticate(cb, token, isAdmin, user) {
    localStorage.setItem('cs.isAuthenticated', '1'); // put here the auth token ?
    localStorage.setItem('cs.authtoken', token);
    localStorage.setItem('cs.isAdmin', isAdmin);
    if (user)
      localStorage.setItem('cs.user', JSON.stringify(user))
    cb && cb();
  },
  signout(cb) {
    localStorage.removeItem('cs.isAuthenticated');
    localStorage.removeItem('cs.authtoken');
    localStorage.removeItem('cs.isAdmin');
    localStorage.removeItem('cs.user');
    cb && cb();
  },
  getUser() {
    var s = localStorage.getItem('cs.user');
    if (s) {
      return JSON.parse(s);
    } else {
      return null;
    }
  }
}

export default fakeAuth;



// WEBPACK FOOTER //
// ./src/fakeAuth.js